require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./styleguide.json") })
        }
      }, "path---styleguide");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---styleguide!./.cache/json/styleguide.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---styleguide!./.cache/json/styleguide.json
// module chunks = 231608221292675